// extracted by css-extract-rspack-plugin
export default {"divider":"divider-ELy1jL","menu":"menu-ntveHq","menu-item":"menu-item-x7eP82","menuItem":"menu-item-x7eP82"};